module.exports = __webpack_public_path__ + "assets/5a6d51cb80889bbbe8fbdb9f7668be70.png";